/*es6-iterator/get*/
function _(require, module, exports) {
    var isArguments = require(274    /* es5-ext/function/is-arguments */), isString = require(310    /* es5-ext/string/is-string */), ArrayIterator = require(312    /* ./array */), StringIterator = require(317    /* ./string */), iterable = require(318    /* ./valid-iterable */), iteratorSymbol = require(325    /* es6-symbol */).iterator;
    module.exports = function (obj) {
        if (typeof iterable(obj)[iteratorSymbol] === 'function')
            return obj[iteratorSymbol]();
        if (isArguments(obj))
            return new ArrayIterator(obj);
        if (isString(obj))
            return new StringIterator(obj);
        return new ArrayIterator(obj);
    };
}